import React, { useState, useEffect } from "react";
import { supabase } from "./supabase";
import Toast from "./components/Toast";
import "./style.css";

// Sistema completo de revistas acadêmicas
function Revistas({ onBack }) {
  const [user, setUser] = useState(null);
  const [revistasPublicadas, setRevistasPublicadas] = useState([]);
  const [meusArtigos, setMeusArtigos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSubmitForm, setShowSubmitForm] = useState(false);
  const [avaliadorMode, setAvaliadorMode] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState("");
  const [activeTab, setActiveTab] = useState("publicadas"); // publicadas, meus, avaliar, producao
  const [toast, setToast] = useState(null);
  const [selectedRevista, setSelectedRevista] = useState(null);
  const [showRevistaModal, setShowRevistaModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [searchTerm, setSearchTerm] = useState("");
  
  // Artigos para avaliação
  const [artigosParaAvaliar, setArtigosParaAvaliar] = useState([]);
  const [artigosEmProducao, setArtigosEmProducao] = useState([]);
  
  // Formulário de novo artigo
  const [novoArtigo, setNovoArtigo] = useState({
    titulo: "",
    resumo: "",
    overleafLink: "",
    autores: "",
    palavrasChave: ""
  });

  // Formulário de publicação de revista
  const [showPublicarRevistaForm, setShowPublicarRevistaForm] = useState(false);
  const [novaRevista, setNovaRevista] = useState({
    edicao: "",
    pdfLink: "",
    artigosIds: []
  });
  
  // Lista de PDFs disponíveis na pasta revistas
  const [pdfsList, setPdfsList] = useState([]);

  const showToast = (message, type = 'info') => {
    setToast({ message, type });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Carregar lista de PDFs da pasta revistas
  useEffect(() => {
    const loadPDFs = async () => {
      try {
        // Lista de PDFs disponíveis (você pode adicionar mais arquivos aqui)
        const pdfs = [
          { name: 'Revista Edição 1.pdf', path: '/revistas/Revista Edição 1.pdf' },
          { name: 'Revista Edição 2.pdf', path: '/revistas/Revista Edição 2.pdf' },
          { name: 'Revista Edição 3.pdf', path: '/revistas/Revista Edição 3.pdf' },
        ];
        setPdfsList(pdfs);
      } catch (error) {
      }
    };
    
    loadPDFs();
  }, []);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        setUser(session.user);
        loadDataForUser(session.user);
      } else {
        setLoading(false);
      }
    };

    checkUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      setUser(session?.user || null);
      if (session?.user) {
        loadDataForUser(session.user);
      } else {
        setLoading(false);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const loadDataForUser = async (currentUser) => {
    try {
      if (!currentUser) {
        setLoading(false);
        return;
      }
      
      // TODO: Migrar para Supabase
      setLoading(false);
      return;
      
      // Carregar revistas publicadas
      // const revistasRef = ref(database, 'revistas');
      // const revistasSnapshot = await get(revistasRef);
      const revistasData = [];
      
      if (revistasSnapshot.exists()) {
        revistasSnapshot.forEach((child) => {
          revistasData.push({
            id: child.key,
            ...child.val()
          });
        });
      }
      
      revistasData.sort((a, b) => b.edicao - a.edicao);
      setRevistasPublicadas(revistasData);
      
      // Carregar artigos
      const artigosRef = ref(database, 'artigos');
      const artigosSnapshot = await get(artigosRef);
      
      const meusArtigosData = [];
      const paraAvaliarData = [];
      const emProducaoData = [];
      
      if (artigosSnapshot.exists()) {
        artigosSnapshot.forEach((child) => {
          const artigo = {
            id: child.key,
            ...child.val()
          };
          
          // Meus artigos
          if (currentUser && artigo.autorId === currentUser.id) {
            meusArtigosData.push(artigo);
          }
          
          // Para avaliar (modo avaliador)
          if (artigo.status === "Em Avaliação") {
            paraAvaliarData.push(artigo);
          }
          
          // Em produção (aceitos mas não publicados)
          if (artigo.status === "Aceito") {
            emProducaoData.push(artigo);
          }
        });
      }
      
      meusArtigosData.sort((a, b) => new Date(b.criadoEm) - new Date(a.criadoEm));
      paraAvaliarData.sort((a, b) => new Date(b.criadoEm) - new Date(a.criadoEm));
      emProducaoData.sort((a, b) => new Date(b.criadoEm) - new Date(a.criadoEm));
      
      setMeusArtigos(meusArtigosData);
      setArtigosParaAvaliar(paraAvaliarData);
      setArtigosEmProducao(emProducaoData);
      
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const loadData = () => {
    if (user) {
      loadDataForUser(user);
    }
  };

  const handleSubmitArtigo = async (e) => {
    e.preventDefault();
    
    if (!novoArtigo.titulo || !novoArtigo.resumo || !novoArtigo.overleafLink) {
      showToast("Preencha título, resumo e link do Overleaf", "warning");
      return;
    }

    if (!novoArtigo.overleafLink.includes('overleaf.com')) {
      showToast("Por favor, insira um link válido do Overleaf", "warning");
      return;
    }

    if (!user) {
      showToast("Você precisa estar logado para submeter artigos", "error");
      return;
    }

    try {
      const userRef = ref(database, `users/${user.id}`);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();
      const artigoData = {
        ...novoArtigo,
        autorId: user.id,
        autorNome: userData?.nome || user.user_metadata?.nome || user.email || "Anônimo",
        autorFoto: userData?.photoURL || user.user_metadata?.avatar_url || "",
        autorVerificado: userData?.verified || false,
        status: "Em Avaliação",
        criadoEm: new Date().toISOString()
      };

      const artigosRef = ref(database, 'artigos');
      await push(artigosRef, artigoData);

      showToast("Artigo submetido com sucesso!", "success");
      setShowSubmitForm(false);
      setNovoArtigo({
        titulo: "",
        resumo: "",
        overleafLink: "",
        autores: "",
        palavrasChave: ""
      });
      loadData();
    } catch (err) {
      showToast("Erro ao submeter artigo: " + err.message, "error");
    }
  };

  const handleAvaliarArtigo = async (artigoId, acao, edicao = null, pagina = null) => {
    try {
      const artigoRef = ref(database, `artigos/${artigoId}`);
      
      if (acao === "aceitar") {
        if (!edicao || !pagina) {
          showToast("Informe a edição e página do artigo", "warning");
          return;
        }
        
        await update(artigoRef, {
          status: "Aceito",
          edicao: parseInt(edicao),
          pagina: parseInt(pagina),
          avaliadoEm: new Date().toISOString()
        });
        
        showToast("Artigo aceito e enviado para produção!", "success");
      } else if (acao === "rejeitar") {
        await update(artigoRef, {
          status: "Rejeitado",
          avaliadoEm: new Date().toISOString()
        });
        
        showToast("Artigo rejeitado", "info");
      }
      
      loadData();
    } catch (err) {
      showToast("Erro ao avaliar artigo", "error");
    }
  };

  const handleDeleteRevista = async (revistaId, e) => {
    e.stopPropagation(); // Evita abrir o modal ao clicar no botão
    
    if (!window.confirm("Tem certeza que deseja excluir esta revista? Esta ação não pode ser desfeita.")) {
      return;
    }

    try {
      // Remove a revista do Firebase
      const revistaRef = ref(database, `revistas/${revistaId}`);
      await set(revistaRef, null);

      showToast("Revista excluída com sucesso!", "success");
      loadData();
    } catch (err) {
      showToast("Erro ao excluir revista: " + err.message, "error");
    }
  };

  const handlePublicarRevista = async (e) => {
    e.preventDefault();
    
    if (!novaRevista.edicao || !novaRevista.pdfLink || novaRevista.artigosIds.length === 0) {
      showToast("Preencha todos os campos e selecione os artigos", "warning");
      return;
    }

    try {
      // Buscar dados dos artigos selecionados
      const artigosData = [];
      for (const artigoId of novaRevista.artigosIds) {
        const artigoRef = ref(database, `artigos/${artigoId}`);
        const snapshot = await get(artigoRef);
        if (snapshot.exists()) {
          artigosData.push({
            id: artigoId,
            ...snapshot.val()
          });
          
          // Atualizar status do artigo para Publicado
          await update(artigoRef, {
            status: "Publicado",
            publicadoEm: new Date().toISOString()
          });
        }
      }

      // Criar revista
      const revistaData = {
        edicao: parseInt(novaRevista.edicao),
        pdfLink: novaRevista.pdfLink,
        artigos: artigosData,
        publicadaEm: new Date().toISOString()
      };

      const revistasRef = ref(database, 'revistas');
      await push(revistasRef, revistaData);

      showToast("Revista publicada com sucesso!", "success");
      setShowPublicarRevistaForm(false);
      setNovaRevista({
        edicao: "",
        pdfLink: "",
        artigosIds: []
      });
      loadData();
    } catch (err) {
      showToast("Erro ao publicar revista", "error");
    }
  };

  const handlePasswordCheck = () => {
    if (password === "revista123") {
      setAvaliadorMode(true);
      setShowPasswordModal(false);
      setPassword("");
      showToast("Modo avaliador ativado", "success");
    } else {
      showToast("Senha incorreta", "error");
      setPassword("");
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case "Em Avaliação": return "#ffa500";
      case "Aceito": return "#4CAF50";
      case "Rejeitado": return "#f44336";
      case "Publicado": return "#2196F3";
      default: return "#666";
    }
  };

  if (loading) {
    return (
      <div className="orkut-loading-screen">
        <div className="orkut-loading-content">
          <h1 className="orkut-loading-title">toNetwork</h1>
          <div className="orkut-loading-text">Carregando...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="orkut-main-layout">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      
      {/* Barra superior de navegação */}
      <div className="orkut-topbar">
        <div className="orkut-topbar-left">
          <a href="#" onClick={(e) => { e.preventDefault(); onBack(); }}>Home</a>
          <a href="#" onClick={(e) => { 
            e.preventDefault(); 
            setActiveTab("publicadas");
          }}>
            Revistas Publicadas
          </a>
          <a href="#" onClick={(e) => { 
            e.preventDefault(); 
            setActiveTab("meus");
          }}>
            Meus Artigos
          </a>
          <a href="#" onClick={(e) => { 
            e.preventDefault(); 
            setShowSubmitForm(true);
          }}>
            Submeter Artigo
          </a>
        </div>
        <div className="orkut-topbar-network">
          <span 
            className="orkut-network-text"
            onClick={() => !avaliadorMode && setShowPasswordModal(true)}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            toNetwork Magazine
            {avaliadorMode && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
              </svg>
            )}
          </span>
        </div>
        <div className="orkut-topbar-right">
          {!isMobile && (
            <input type="text" placeholder="buscar revistas" className="orkut-search" />
          )}
          {avaliadorMode && !isMobile && (
            <>
              <button 
                className="orkut-btn-secondary"
                onClick={() => setActiveTab("avaliar")}
                style={{ marginRight: '10px' }}
              >
                Para Avaliar ({artigosParaAvaliar.length})
              </button>
              <button 
                className="orkut-btn-secondary"
                onClick={() => setActiveTab("producao")}
              >
                Em Produção ({artigosEmProducao.length})
              </button>
            </>
          )}
        </div>
      </div>

      <div className="orkut-content">
        <main className="orkut-articles-main">
      
      {/* Conteúdo das Tabs */}
      {activeTab === "publicadas" && (
        <div>
          {revistasPublicadas.length === 0 ? (
            <div style={{
              background: 'white',
              padding: '40px',
              borderRadius: '12px',
              textAlign: 'center',
              color: '#666'
            }}>
              Nenhuma revista publicada ainda
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {revistasPublicadas.map((revista) => 
                <div key={revista.id} style={{
                  background: 'white',
                  padding: window.innerWidth <= 768 ? '16px' : '24px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  position: 'relative'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                onClick={() => {
                  setSelectedRevista(revista);
                  setShowRevistaModal(true);
                }}>
                  {/* Botão de excluir (só para avaliador) */}
                  {avaliadorMode && (
                    <button
                      onClick={(e) => handleDeleteRevista(revista.id, e)}
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: '#d73527',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        fontSize: '12px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        zIndex: 10
                      }}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        e.target.style.background = '#b02a1f';
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        e.target.style.background = '#d73527';
                      }}
                    >
                      🗑️ Excluir
                    </button>
                  )}
                  <h3 style={{ 
                    margin: '0 0 10px 0', 
                    color: '#2d5aa0',
                    fontSize: window.innerWidth <= 768 ? '1.1em' : '1.3em',
                    paddingRight: avaliadorMode ? '100px' : '0'
                  }}>
                    Revista toNetwork - {revista.edicao}ª Edição
                  </h3>
                  <p style={{ color: '#666', fontSize: '14px', margin: '5px 0' }}>
                    {revista.artigos?.length || 0} artigos publicados
                  </p>
                  <p style={{ color: '#999', fontSize: '12px' }}>
                    Publicada em {new Date(revista.publicadaEm).toLocaleDateString('pt-BR')}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {activeTab === "meus" && (
        <div>
          {meusArtigos.length === 0 ? (
            <div style={{
              background: 'white',
              padding: '40px',
              borderRadius: '12px',
              textAlign: 'center',
              color: '#666'
            }}>
              Você ainda não submeteu nenhum artigo
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {meusArtigos.map((artigo) => (
                <div key={artigo.id} style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  borderLeft: `4px solid ${getStatusColor(artigo.status)}`
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>{artigo.titulo}</h3>
                      <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
                        {artigo.resumo}
                      </p>
                      {artigo.autores && (
                        <p style={{ color: '#999', fontSize: '13px', margin: '5px 0' }}>
                          <strong>Coautores:</strong> {artigo.autores}
                        </p>
                      )}
                      {artigo.status === "Aceito" && (
                        <p style={{ color: '#4CAF50', fontSize: '13px', fontWeight: '600', margin: '5px 0' }}>
                          Aceito para Edição {artigo.edicao} - Página {artigo.pagina}
                        </p>
                      )}
                    </div>
                    <span style={{
                      padding: '6px 12px',
                      background: getStatusColor(artigo.status),
                      color: 'white',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: '600',
                      whiteSpace: 'nowrap'
                    }}>
                      {artigo.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeTab === "avaliar" && avaliadorMode && (
        <div>
          {artigosParaAvaliar.length === 0 ? (
            <div style={{
              background: 'white',
              padding: '40px',
              borderRadius: '12px',
              textAlign: 'center',
              color: '#666'
            }}>
              Nenhum artigo para avaliar
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {artigosParaAvaliar.map((artigo) => (
                <ArtigoParaAvaliar 
                  key={artigo.id} 
                  artigo={artigo} 
                  onAvaliar={handleAvaliarArtigo}
                />
              ))}
            </div>
          )}
        </div>
      )}

      {activeTab === "producao" && avaliadorMode && (
        <div>
          <div style={{ marginBottom: '15px' }}>
            <button onClick={() => setShowPublicarRevistaForm(true)} style={{
              padding: '12px 24px',
              background: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer'
            }}>
              Publicar Nova Revista
            </button>
          </div>
          
          {artigosEmProducao.length === 0 ? (
            <div style={{
              background: 'white',
              padding: '40px',
              borderRadius: '12px',
              textAlign: 'center',
              color: '#666'
            }}>
              Nenhum artigo em produção
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {artigosEmProducao.map((artigo) => (
                <div key={artigo.id} style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  borderLeft: '4px solid #4CAF50'
                }}>
                  <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>{artigo.titulo}</h3>
                  <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
                    {artigo.resumo}
                  </p>
                  <div style={{ display: 'flex', gap: '15px', color: '#999', fontSize: '13px' }}>
                    <span><strong>Edição:</strong> {artigo.edicao}</span>
                    <span><strong>Página:</strong> {artigo.pagina}</span>
                    <span><strong>Autor:</strong> {artigo.autorNome}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      
        </main>
      </div>

      {/* Modal de Senha */}
      {showPasswordModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '400px'
          }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#2d5aa0' }}>Modo Avaliador</h3>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handlePasswordCheck()}
              placeholder="Digite a senha"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e0e0e0',
                borderRadius: '8px',
                fontSize: '16px',
                marginBottom: '15px'
              }}
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={handlePasswordCheck} style={{
                flex: 1,
                padding: '12px',
                background: '#2d5aa0',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer'
              }}>
                Confirmar
              </button>
              <button onClick={() => {
                setShowPasswordModal(false);
                setPassword("");
              }} style={{
                flex: 1,
                padding: '12px',
                background: '#f0f0f0',
                color: '#666',
                border: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer'
              }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Submissão */}
      {showSubmitForm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          overflowY: 'auto',
          padding: window.innerWidth <= 768 ? '10px' : '20px'
        }}>
          <div style={{
            background: 'white',
            padding: window.innerWidth <= 768 ? '20px' : '30px',
            borderRadius: '12px',
            width: window.innerWidth <= 768 ? '95%' : '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <h3 style={{ 
              margin: '0 0 20px 0', 
              color: '#2d5aa0',
              fontSize: window.innerWidth <= 768 ? '1.2em' : '1.4em'
            }}>Submeter Artigo</h3>
            
            {/* Botão para baixar modelo */}
            <div style={{ 
              marginBottom: '20px', 
              padding: '15px', 
              background: '#f0f7ff', 
              borderRadius: '8px',
              border: '1px solid #c3d9ff'
            }}>
              <p style={{ margin: '0 0 10px 0', color: '#333', fontWeight: '600' }}>
                📄 Modelo de Artigo
              </p>
              <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>
                Baixe o modelo LaTeX para formatar seu artigo corretamente:
              </p>
              <a 
                href="/modelo_tonetwork.tex" 
                download="modelo_tonetwork.tex"
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  background: '#2d5aa0',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '6px',
                  fontWeight: '600',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = '#1e3a70'}
                onMouseLeave={(e) => e.target.style.background = '#2d5aa0'}
              >
                ⬇️ Baixar Modelo (.tex)
              </a>
            </div>

            <form onSubmit={handleSubmitArtigo}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  Título *
                </label>
                <input
                  type="text"
                  value={novoArtigo.titulo}
                  onChange={(e) => setNovoArtigo({...novoArtigo, titulo: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    boxSizing: 'border-box'
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  Resumo *
                </label>
                <textarea
                  value={novoArtigo.resumo}
                  onChange={(e) => setNovoArtigo({...novoArtigo, resumo: e.target.value})}
                  rows={4}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    resize: 'vertical',
                    boxSizing: 'border-box'
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  Link do Overleaf *
                </label>
                <input
                  type="url"
                  value={novoArtigo.overleafLink}
                  onChange={(e) => setNovoArtigo({...novoArtigo, overleafLink: e.target.value})}
                  placeholder="https://www.overleaf.com/read/..."
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    boxSizing: 'border-box'
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  Coautores (opcional)
                </label>
                <input
                  type="text"
                  value={novoArtigo.autores}
                  onChange={(e) => setNovoArtigo({...novoArtigo, autores: e.target.value})}
                  placeholder="Nome dos coautores separados por vírgula"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  Palavras-chave
                </label>
                <input
                  type="text"
                  value={novoArtigo.palavrasChave}
                  onChange={(e) => setNovoArtigo({...novoArtigo, palavrasChave: e.target.value})}
                  placeholder="Palavras-chave separadas por vírgula"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" style={{
                  flex: 1,
                  padding: '12px',
                  background: '#2d5aa0',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Submeter
                </button>
                <button type="button" onClick={() => setShowSubmitForm(false)} style={{
                  flex: 1,
                  padding: '12px',
                  background: '#f0f0f0',
                  color: '#666',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Revista */}
      {showRevistaModal && selectedRevista && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          overflowY: 'auto',
          padding: window.innerWidth <= 768 ? '10px' : '20px'
        }}>
          <div style={{
            background: 'white',
            padding: window.innerWidth <= 768 ? '20px' : '30px',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <h2 style={{ 
              margin: '0 0 20px 0', 
              color: '#2d5aa0',
              fontSize: window.innerWidth <= 768 ? '1.3em' : '1.5em'
            }}>
              Revista toNetwork - Edição {selectedRevista.edicao}
            </h2>
            
            <a 
              href={selectedRevista.pdfLink} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                background: '#2d5aa0',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                marginBottom: '30px'
              }}
            >
              Baixar PDF Completo
            </a>

            <h3 style={{ margin: '20px 0', color: '#333', borderBottom: '2px solid #e0e0e0', paddingBottom: '10px' }}>
              Sumário
            </h3>

            {/* Campo de busca no modal */}
            <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                placeholder="Filtrar artigos por título, coautores ou palavras-chave..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#2d5aa0'}
                onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {selectedRevista.artigos?.filter(artigo => {
                if (!searchTerm) return true;
                const search = searchTerm.toLowerCase();
                return (
                  artigo.titulo?.toLowerCase().includes(search) ||
                  artigo.autores?.toLowerCase().includes(search) ||
                  artigo.palavrasChave?.toLowerCase().includes(search) ||
                  artigo.resumo?.toLowerCase().includes(search)
                );
              }).length === 0 ? (
                <div style={{
                  padding: '40px',
                  textAlign: 'center',
                  color: '#999',
                  background: '#f8f9fa',
                  borderRadius: '8px'
                }}>
                  Nenhum artigo encontrado com "{searchTerm}"
                </div>
              ) : (
                selectedRevista.artigos?.filter(artigo => {
                  if (!searchTerm) return true;
                  const search = searchTerm.toLowerCase();
                  return (
                    artigo.titulo?.toLowerCase().includes(search) ||
                    artigo.autores?.toLowerCase().includes(search) ||
                    artigo.palavrasChave?.toLowerCase().includes(search) ||
                    artigo.resumo?.toLowerCase().includes(search)
                  );
                }).map((artigo, index) => (
                <div key={index} style={{
                  padding: '20px',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  borderLeft: '4px solid #2d5aa0'
                }}>
                  <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>
                    {artigo.titulo}
                  </h4>
                  <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
                    {artigo.resumo}
                  </p>
                  <div style={{ display: 'flex', gap: '15px', color: '#999', fontSize: '13px' }}>
                    <span><strong>Autor:</strong> {artigo.autorNome}</span>
                    {artigo.autores && <span><strong>Coautores:</strong> {artigo.autores}</span>}
                    <span><strong>Página:</strong> {artigo.pagina}</span>
                  </div>
                </div>
              ))
              )}
            </div>

            <button onClick={() => setShowRevistaModal(false)} style={{
              marginTop: '20px',
              padding: '12px 24px',
              background: '#f0f0f0',
              color: '#666',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%'
            }}>
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* Modal de Publicar Revista */}
      {showPublicarRevistaForm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          overflowY: 'auto',
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <h3 style={{ margin: '0 0 20px 0', color: '#2d5aa0' }}>Publicar Nova Revista</h3>
            <form onSubmit={handlePublicarRevista}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  Número da Edição *
                </label>
                <input
                  type="number"
                  value={novaRevista.edicao}
                  onChange={(e) => setNovaRevista({...novaRevista, edicao: e.target.value})}
                  placeholder="Ex: 1"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '600', color: '#333' }}>
                  PDF da Revista *
                </label>
                <select
                  value={novaRevista.pdfLink}
                  onChange={(e) => setNovaRevista({...novaRevista, pdfLink: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '16px',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                  }}
                  required
                >
                  <option value="">Selecione um PDF...</option>
                  {pdfsList.map((pdf, index) => (
                    <option key={index} value={pdf.path}>
                      {pdf.name}
                    </option>
                  ))}
                </select>
                <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
                  💡 Os PDFs devem estar na pasta <code>/public/revistas/</code>
                </p>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '10px', fontWeight: '600', color: '#333' }}>
                  Selecione os Artigos * ({novaRevista.artigosIds.length} selecionados)
                </label>
                <div style={{ 
                  maxHeight: '300px', 
                  overflowY: 'auto',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '10px'
                }}>
                  {artigosEmProducao.map((artigo) => (
                    <label key={artigo.id} style={{
                      display: 'block',
                      padding: '10px',
                      background: novaRevista.artigosIds.includes(artigo.id) ? '#e3f2fd' : 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      marginBottom: '8px',
                      cursor: 'pointer'
                    }}>
                      <input
                        type="checkbox"
                        checked={novaRevista.artigosIds.includes(artigo.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setNovaRevista({
                              ...novaRevista,
                              artigosIds: [...novaRevista.artigosIds, artigo.id]
                            });
                          } else {
                            setNovaRevista({
                              ...novaRevista,
                              artigosIds: novaRevista.artigosIds.filter(id => id !== artigo.id)
                            });
                          }
                        }}
                        style={{ marginRight: '10px' }}
                      />
                      <span style={{ fontWeight: '600' }}>{artigo.titulo}</span>
                      <span style={{ color: '#666', fontSize: '13px', marginLeft: '10px' }}>
                        (Ed. {artigo.edicao}, p. {artigo.pagina})
                      </span>
                    </label>
                  ))}
                  
                  {artigosEmProducao.length === 0 && (
                    <p style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
                      Nenhum artigo em produção disponível
                    </p>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" style={{
                  flex: 1,
                  padding: '12px',
                  background: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Publicar Revista
                </button>
                <button type="button" onClick={() => {
                  setShowPublicarRevistaForm(false);
                  setNovaRevista({ edicao: "", pdfLink: "", artigosIds: [] });
                }} style={{
                  flex: 1,
                  padding: '12px',
                  background: '#f0f0f0',
                  color: '#666',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Barra de navegação mobile */}
      <div className="orkut-mobile-nav">
        <button className="orkut-mobile-nav-btn" onClick={() => onBack()}>
          <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
          </svg>
          <span>Home</span>
        </button>
        <button className="orkut-mobile-nav-btn" onClick={() => setActiveTab("publicadas")}>
          <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
          </svg>
          <span>Publicadas</span>
        </button>
        <button className="orkut-mobile-nav-btn" onClick={() => setActiveTab("meus")}>
          <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
          </svg>
          <span>Meus</span>
        </button>
        <button className="orkut-mobile-nav-btn" onClick={() => setShowSubmitForm(true)}>
          <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
          </svg>
          <span>Submeter</span>
        </button>
      </div>
    </div>
  );
}

// Componente para card de artigo a ser avaliado
function ArtigoParaAvaliar({ artigo, onAvaliar }) {
  const [showAvaliarForm, setShowAvaliarForm] = useState(false);
  const [edicao, setEdicao] = useState("");
  const [pagina, setPagina] = useState("");

  return (
    <div style={{
      background: 'white',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      borderLeft: '4px solid #ffa500'
    }}>
      <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>{artigo.titulo}</h3>
      <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
        {artigo.resumo}
      </p>
      
      {artigo.autores && (
        <p style={{ color: '#999', fontSize: '13px', margin: '5px 0' }}>
          <strong>Coautores:</strong> {artigo.autores}
        </p>
      )}
      
      {artigo.palavrasChave && (
        <p style={{ color: '#999', fontSize: '13px', margin: '5px 0' }}>
          <strong>Palavras-chave:</strong> {artigo.palavrasChave}
        </p>
      )}

      <p style={{ color: '#999', fontSize: '13px', margin: '5px 0' }}>
        <strong>Submetido por:</strong> {artigo.autorNome}
      </p>

      <div style={{ marginTop: '15px' }}>
        <a 
          href={artigo.overleafLink} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '8px 16px',
            background: '#f0f4f9',
            color: '#2d5aa0',
            textDecoration: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            marginRight: '10px'
          }}
        >
          Ver no Overleaf
        </a>
      </div>

      {!showAvaliarForm ? (
        <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
          <button onClick={() => setShowAvaliarForm(true)} style={{
            padding: '10px 20px',
            background: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            cursor: 'pointer'
          }}>
            Aceitar
          </button>
          <button onClick={() => {
            if (window.confirm('Tem certeza que deseja rejeitar este artigo?')) {
              onAvaliar(artigo.id, "rejeitar");
            }
          }} style={{
            padding: '10px 20px',
            background: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            cursor: 'pointer'
          }}>
            Rejeitar
          </button>
        </div>
      ) : (
        <div style={{
          marginTop: '15px',
          padding: '15px',
          background: '#f8f9fa',
          borderRadius: '8px'
        }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Aceitar Artigo</h4>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '600' }}>
                Edição
              </label>
              <input
                type="number"
                value={edicao}
                onChange={(e) => setEdicao(e.target.value)}
                placeholder="Ex: 1"
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '6px'
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '600' }}>
                Página
              </label>
              <input
                type="number"
                value={pagina}
                onChange={(e) => setPagina(e.target.value)}
                placeholder="Ex: 15"
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '6px'
                }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={() => {
              onAvaliar(artigo.id, "aceitar", edicao, pagina);
              setShowAvaliarForm(false);
            }} style={{
              flex: 1,
              padding: '8px',
              background: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              cursor: 'pointer'
            }}>
              Confirmar
            </button>
            <button onClick={() => setShowAvaliarForm(false)} style={{
              flex: 1,
              padding: '8px',
              background: '#f0f0f0',
              color: '#666',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              cursor: 'pointer'
            }}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Revistas;
